import { CircleHelp } from 'lucide-react';
import type { ReactNode } from 'react';

/**
 * A reading guide behind a help icon.
 *
 * A native `<details>`, for the reason `ExplainerCard` gives: keyboard and
 * screen-reader behaviour without any of our code. Closed, it is one small icon
 * that names itself (`aria-label`, tooltip and screen-reader text all carry the
 * guide's title); open, it takes the full width and shows the guide.
 */
export function HelpToggle({ title, children }: { title: string; children: ReactNode }) {
  return (
    <details className="group w-fit rounded-md border border-dashed bg-muted/30 open:w-full" data-help>
      <summary
        aria-label={title}
        title={title}
        className="flex cursor-pointer list-none items-center gap-1.5 p-1.5 text-muted-foreground hover:text-foreground"
      >
        <CircleHelp className="h-4 w-4 shrink-0" aria-hidden />
        <span className="sr-only">{title}</span>
      </summary>
      <div className="space-y-2 px-3 pb-3 pt-1">{children}</div>
    </details>
  );
}
